<template>
  <div v-title data-title="产品详情">
    <section style="padding-bottom:50px;">
      <div class="userinfo" >
        <div class="wechatimg">
          <img v-if="formset.IsShowWechatHeadImg" :src="formset.ShowWechatHeadImg" width="40" height="40" />
          <img v-if="!formset.IsShowWechatHeadImg" src="../../assets/logo.png" width="40" height="40" />
        </div>
        <div class="wechattitle">
          <font class="wechatname"  v-if="formset.IsShowWechatHeadImg" >{{formset.ShowWechatName}}&nbsp;</font>
          <font class="wechatname"  v-if="!formset.IsShowWechatHeadImg" >壹选生活&nbsp;</font>
          <font class="productname">推荐&nbsp;{{formset.ProductName}}</font>
        </div>
      </div>
      <div class="pro-list pro-details" style="padding-bottom:1px;margin-top:46px;">
        <wv-swipe :height="210" :autoplay="3000">
          <wv-swipe-item v-for="(url,$index) in this.formset.ProductImgUrl" :key="$index">
            <div class="swipe-img-div" style="height:210px;">
              <img v-lazy="url" class="lazy-img-fadein" :key="$index" />
            </div>
          </wv-swipe-item>
        </wv-swipe>
        <!-- <div class="pro-num">
          <span>产品编号：{{formset.ProductNumber}}</span>
        </div>-->

        <!-- <div class="tags">
          <span
            v-for="(tag,$index) in comboTags"
            :key="$index"
            class="label-bg"
            :style="$index==0&&formset.ProductType==6?'display:none':''"
          >{{tag}}</span>
        </div>-->

        <div class="price" style>
          <span>
            ￥
            <b>{{CommissionInfo.SalePrice}}</b>
            <span
              style="color:#999; text-decoration:line-through;font-size:14px;"
            >&nbsp;市场价：￥{{CommissionInfo.PrimePrice}}</span>
            <span style="float:right;padding: 0px 5px;" v-if="CommissionInfo.IsShowStock">
              <span style="color:#999;font-size:14px;">已售: {{CommissionInfo.AllSoldCount}}</span>
              <span
                style="color:#999;font-size:14px;"
              >&nbsp;&nbsp;&nbsp;剩余: {{CommissionInfo.AllStockCount}}</span>
            </span>
            <!-- <span
              class="fr"
              v-if="formset.LoginType==4&&this.formset.IsDistribute==1"
            >佣金：￥{{CommissionInfo.Commission}}</span>-->
          </span>
          <!-- <p style="color:#999; text-decoration:line-through">
            市场价：￥{{CommissionInfo.PrimePrice}}
             <span
              class="fr"
              v-if="formset.LoginType==4&&this.formset.IsDistribute==1">
              <span style="color:#999;">(客户不可见)</span>
            </span>
          </p>-->
        </div>
        <div
          class="title"
          @click="clicktocopy()"
          id="copyBtn"
          data-clipboard-action="copy"
          data-clipboard-target="#producttarget"
        >
          <a href="javascript:void(0)" id="producttarget" style="font-weight: bold;">{{formset.ProductName}}</a>
          <!-- <div
            @click="clicktocopy()"
            class="productcopy"
            id="copyBtn"
            data-clipboard-action="copy"
            data-clipboard-target="#producttarget"
          >
            <img src="../../assets/img/icon27.png" style="width:20px;vertical-align:middle" />
            <span
              style="margin-left:2px;vertical-align:middle;color:#484848;margin-bottom:10px"
            >复制产品名称</font>
          </div>-->
        </div>
        <!--
        <div class="stock" v-if="CommissionInfo.IsShowStock">
          <span>已售: {{CommissionInfo.AllSoldCount}}</span>
          <span style="float:right">库存: {{CommissionInfo.AllStockCount}}</span>
        </div>-->
      </div>
      <div class="payment" style="margin:0px;">
        <a href="javascript:void(0)" class="block" @click="PopupProductInfo()">
          <div class="link-t">已选</div>
          <div class="link-txt">{{formset.ComboName}}；1件</div>
        </a>
        <a href="javascript:void(0)" class="block" @click="todeliveryaddress()">
          <div class="link-t">配送</div>
          <div class="link-txt">发送至{{Province}} {{City}} {{District}}</div>
        </a>
        
        <a href="javascript:void(0)" class="block">
          <div class="link-t">运费</div>
          <div
            v-if="!isRefusePostArea&&IsFreeShipping==1"
            class="link-txt"
          >包邮</div>
          <div
            v-if="isRefusePostArea"
            class="link-txt"
          >当前地址不发货</div>
          <div
            v-if="!isRefusePostArea&&IsFreeShipping==0"
            class="link-txt"
          >￥{{currentPostage}}</div>
        </a>
      </div>
      <!-- 返回顶部-->
      <!-- <wvi-gotop></wvi-gotop> -->
      <!--生成海报-->
      <!-- <div
        @click="PosterOrShowTitle()"
        class="generateposters"
        v-if="formset.LoginType==4&&this.formset.IsDistribute==1"
      >
        <img src="../../assets/img/generate.png" />
      </div>-->

      <div style v-if="formset.ProductType!=6">
        <div class="mssj" v-for="(info,$index) in BusinessInfos" :key="$index">
          <div class="fl">
            <div class="adress">
              <p class="adress-info" @click="toMap(info.lng,info.lat)">{{info.Adress}}</p>
            </div>
            <div class="tel" @click="zixun(info.Phone)">{{info.Phone}}</div>
          </div>
          <div class="fr">
            <img v-if="info.Type=='住宿商家'" src="../../assets/img/icon23-1.png" />
            <img v-if="info.Type=='美食商家'" src="../../assets/img/icon23-2.png" />
            <img v-if="info.Type=='玩乐商家'" src="../../assets/img/icon23-3.png" />
            <img v-if="info.Type=='生活服务'" src="../../assets/img/icon23-4.png" />
            <img v-if="info.Type=='好货'" src="../../assets/img/icon23-5.png" />
          </div>
          <div style="clear:both;"></div>
        </div>
      </div>
      <!-- <div v-show="ComboOptions.length>1" class="block-t">套餐类型</div>
      <div v-show="ComboOptions.length>1" style="margin-top: -1.6rem;font-size:1.3rem">
        <wv-radio v-model="comboguid" :options="ComboOptions" @change="onChange"></wv-radio>
      </div> -->

      <div class="weui-panel weui-panel_access weui-media-box" v-if="CommissionInfo.PriceType==2">
        <wvi-calendar
          v-if="CommissionInfo.PriceType==2&&showcalendar"
          ref="Calendar"
          :sundayStart="true"
          :markDate="markDate"
          agoDayHide="1530115200"
          v-on:chooseDay="clickDay"
          v-on:changeMonth="changeDate"
        ></wvi-calendar>
      </div>

      <!-- <div
        style="height:5.0rem;line-height:5.0rem;background-color:white; font-size:1.5rem"
        :class="floattab?'tab-float':''"
      >
        <div
          style="display:block;float:left;width:25%;text-align:center;"
          @click="goto('ComboContent')"
          :class="PagePosition=='ComboContent'?'tab-activett':''"
        >套餐详情</div>
        <div
          style="display:block;float:left;width:25%;text-align:center;"
          @click="goto('ProductContent')"
          :class="PagePosition=='ProductContent'?'tab-activett':''"
        >产品详情</div>
        <div
          style="display:block;float:left;width:25%;text-align:center;"
          @click="goto('ReservationContent')"
          :class="PagePosition=='ReservationContent'?'tab-activett':''"
        >预定须知</div>
        <div
          style="display:block;float:left;width:25%;text-align:center;"
          @click="goto('ChangeContent')"
          :class="PagePosition=='ChangeContent'?'tab-activett':''"
        >退改说明</div>
      </div>-->
      <div class="banner-flex" style="background-color: #fff;">
        <div class="banner-logo"><img :src="formset.SysCompany.LogoUrl"/></div>
        <div class="banner-t">
          <p class="title">{{formset.SysCompany.ShopName}}</p>
          <p class="date">入驻时间：{{formset.SysCompany.CreateTime | date('yyyy-MM-dd')}}</p>
          <p class="info">{{formset.SysCompany.ProductCount}}件<span>商品</span>48小时内<span>发货</span></p>
        </div>
        <!-- <div class="banner-button">
          <button class="fl">关注</button>
          <button class="fr">进店</button>
        </div> -->
      </div>
      <div style="font-size:1.6rem">
        <div id="ComboContent" style="height:1px"></div>
        <div style="background-color:#fff" v-if="CommissionInfo.ComboContent.length>0">
          <div class="details-con-t">
            <div>套餐详情</div>
            <span>INTRODUE</span>
          </div>
          <div class="productcontent tab-item-detail" v-html="CommissionInfo.ComboContent"></div>
        </div>

        <div id="ProductContent" style="height:30px" v-if="CommissionInfo.ComboContent.length>0"></div>
        <div style="background-color:#fff">
          <div class="details-con-t">
            <div>产品详情</div>
            <span>INTRODUE</span>
          </div>
          <div class="productcontent tab-item-detail" v-html="formset.ProductContent"></div>
        </div>

        <div id="ReservationContent" style="height:30px"></div>
        <div style="background-color:#fff">
          <div class="details-con-t">
            <div>预定须知</div>
            <span>RESERVATION</span>
          </div>
          <div class="productcontent tab-item-detail" v-html="formset.ReservationContent"></div>
        </div>

        <div id="ChangeContent" style="height:30px"></div>
        <div style="background-color:#fff">
          <div class="details-con-t">
            <div>退改说明</div>
            <span>INTRODUCE</span>
          </div>
          <div class="productcontent tab-item-detail" v-html="formset.ChangeContent"></div>
        </div>

        <div v-if="products.length>0" style="background-color:#fff;margin-top: 15px;padding:15px;">

          <div class="pro-title">
            <span>猜你喜欢</span>
          </div>
          <ul class="pros-list">
            <li
              class="flex"
              v-for=" (model,$index) in products"
              :key="$index"
              @click="ProductDetail(model.Guid)"
            >
              <div class="pro-img">
                <a href="javascript:void(0)">
                  <img :src="model.ProductFirstPic" />
                </a>
                <span
                  style="background-size:32px;padding:1px 5px 10px"
                  v-if="model.IsNew==1"
                  class="tag-new"
                >新品</span>
              </div>
              <div class="pro-desc">
                <a
                  href="javascript:void(0)"
                  class="title"
                  style="max-height:42px;"
                >{{model.ProductName}}</a>
                <p class="price">
                  <span>
                    ￥
                    <b>{{model.SatrtAmount}}</b>
                  </span>
                  <span class="gray">￥{{model.PrimePrice}}</span>
                </p>
                <p class="flex">
                  <span>已售:{{model.ProductSaleCount}}</span>
                  <span
                    v-if="LoginType==4&&model.IsDistribute==1"
                    class="btn-tag"
                  >赚￥{{model.Commission}}</span>
                  <span v-else class="btn-tag">立即预定</span>
                  <!-- <span><img src="../../assets/img/shop.png" width="25"/></span> -->
                </p>
              </div>
            </li>
          </ul>
          <div class="pro">
            <p v-if="products.length!=NewTotalCount"><span @click="InitNewProduct()" class="btn-more">&gt;&gt;换一批&lt;&lt;</span></p>
            <p v-if="products.length==NewTotalCount"><span style="background: #999;" class="btn-more">更多产品敬请期待</span></p>
          </div>
        </div>
      </div>
    </section>
    <!--商品选择-->
    <wv-popup :visible.sync="popupProductInfo" id="dvComPop" style="width:100%; padding:20px;padding-bottom: 100px;max-height: 100%;" class="pop-produce">
      <div class="pop-pro-price">
        <div class="pop-pro-img"><img :src='formset.ProductImgUrl[0]'/></div>
        <div class="pop-pro-selected">
          <p class="price" v-if="LoginType==5">{{(CommissionInfo.SalePrice)|currency('￥',2)}}</p>
          <p class="price" v-if="LoginType==4">{{(CommissionInfo.SalePrice-CommissionInfo.DeductAmount)|currency('￥',2)}}</p>
        <p>已选：{{formset.ComboName}}</p></div>
      </div>
      <div class="pop-pro-select" style="height: 80%;overflow: hidden;">
        <p>选择套餐</p>
        <div class="select-btn" style="height: 89%;overflow-y: scroll;">
          <button @click="onChange(model.value)"  :class="model.value==comboguid?'active':''" v-for=" (model,$index) in formset.ComboOptions"
              :key="$index">{{model.label}}</button>
        </div>
      </div>
      <div class="pop-pro-num">
        <p>购买数量</p>
        <div class="num-input">
            <button v-if="allCount<=1" class="disable">-</button>
            <button v-else @click="allCount=allCount-1 ,CalculatePostFee()">-</button>

            <input readonly v-on:change="CalculatePostFee()" type="number" v-model="allCount" />
            <button v-if="allCount>=CommissionInfo.AllStockCount" class="disable">+</button>
            <button v-else @click="allCount=allCount+1,CalculatePostFee()">+</button>
          </div><span>库存{{CommissionInfo.AllStockCount}}件</span>
      </div>
      <button class="btn-block fix-b" @click="Shop()">确定</button>
    </wv-popup>

    <!-- 海报logo选择-->
    <wv-popup :visible.sync="popupVisiblelogo" height="250" style="width:100%">
      <wv-checklist title="海报Logo选择" v-model="logochoose" :options="SelectLogos"></wv-checklist>
      <wv-button
        type="primary"
        :mini="true"
        style="background-color:rgb(255, 152, 0);width:50%;height:40px;position:fixed;bottom:0"
        @click="GeneratePoster()"
      >生成</wv-button>
      <wv-button
        type="default"
        :mini="true"
        style="height:40px;right:0px;width:50%;position:fixed;bottom:0"
        @click="popupVisiblelogo=false"
      >取消</wv-button>
    </wv-popup>

    <!-- 海报或分享信息选择-->
    <wv-popup :visible.sync="posterOrShowTitle" height="160" style="width:100%">
      <div @click="GeneratePoster()" style="width:33%;float:left;text-align:center">
        <div style="height: 50px;margin-top: 40px;" v-if="posterOrShowTitle" class="generateback"></div>
        <p @click="GeneratePoster()" style="text-align:center;padding-top:5px">生成海报</p>
      </div>
      <div @click="showTitlePre()" style="width:33%;float:left;text-align:center">
        <div style="height: 50px;margin-top: 40px;" v-if="posterOrShowTitle" class="shareback"></div>
        <p @click="showTitlePre()" style="text-align:center;padding-top:5px">分享信息</p>
      </div>

      <div
        id="shareurl"
        style="width:33%;float:left;text-align:center"
      >
      <input style="width:1px;height:1px;float:right;border:0px;opacity: 0;" v-model="shareurl" id="shareurl1" />
        <div @click="copyshareurl('shareurlDiv')" id="shareurlDiv" data-clipboard-action="copy" data-clipboard-target="#shareurl1" style="height: 50px;margin-top: 40px;" v-if="posterOrShowTitle" class="shareurl"></div>
        <p @click="copyshareurl('shareurlP')" id="shareurlP" data-clipboard-action="copy" data-clipboard-target="#shareurl1" style="text-align:center;padding-top:5px">复制链接</p>
      </div>
    </wv-popup>

    <!-- 海报图-->
    <wv-popup :visible.sync="popupVisiblediy" height="100%">
      <scroller style="position:fixed;top:0;text-align:center;">
        <img
          v-if="popupVisiblediy"
          v-bind:src="'data:image/png;base64,'+posterbase64"
          style="width:70%; margin-top:20px;"
        />
        <div style="text-align:center;color:black;font-size:16px">长按海报保存到手机或者发送</div>
        <div style="text-align:center;" @click="popupVisiblediy=false">
          <i data-v-460a00e2 class="weui-icon-cancel"></i>
        </div>
      </scroller>
    </wv-popup>
    <!-- 分享图-->
    <wv-popup :visible.sync="popupVisibleshare" height="0" style="position:fixed;top:0">
      <img
        v-if="popupVisibleshare"
        @click="popupVisibleshare=false"
        v-bind:src="sharereminder"
        style="width:100%;opacity:0.8"
      />
      <!-- <div style="text-align:center" @click="popupVisibleshare=false">
        <i data-v-460a00e2 class="weui-icon-cancel"></i>
      </div>-->
    </wv-popup>
    <!--家游客显示-->
    <!-- <div class="fenxiao-switch" v-if="LoginType==4&&disid!=LoginGuid">
      <span @click="ToMyFSX()">
        想自己分销产品？
        <a>点击切换>></a>
      </span>
    </div>-->

    <!--底部导航-->
    <footer class="fix-b" style="z-index:999">
      <div
        v-if="formset.IsOnSale==0&&formset.IsState==1&&CommissionInfo.IsState==1&&comboIsState==1&&!CommissionInfo.isSoldOut"
        class="js-count-down countdown-warp on tips-warn"
        data-start="1556244000000"
        data-end="1557043200000"
      >
        距开售 仅剩
        <span class="date_day J_day">{{timer_day}}</span> 天
        <span class="date_hours J_hours">{{timer_hour}}</span> :
        <span class="date_minutes J_minutes">{{timer_min}}</span> :
        <span class="J_seconds">{{timer_sec}}</span>
      </div>
      <div class="weui-flex pro-tooler">
        <div class="weui-flex__item">
          <!--
          -->
          <div class="weui-flex">
            <div class="weui-flex__item">
              <a class="home" @click="ToHome()">首页</a>
            </div>
          </div>
        </div>

        <div
          v-if="LoginType==4"
          class="weui-flex__item"
          @click="PosterOrShowTitle()"
          style="background: #e8af70;color:#ffffff"
        >
          <span v-if="LoginType==5" style="margin-top:10px" class="share-font">转发</span>
          <span v-if="LoginType==4" class="share-font">转发</span>
          <span class="economize" v-if="LoginType==4">赚￥{{CommissionInfo.Commission}}</span>
        </div>

        <div
          v-if="LoginType==5"
          class="weui-flex__item"
          @click="popupVisibleshare=true"
          style="background: #e8af70;color:#ffffff"
        >
          <span v-if="LoginType==5" style="margin-top:10px" class="share-font">转发</span>
          <span v-if="LoginType==4" class="share-font">转发</span>
          <span class="economize" v-if="LoginType==4">赚￥{{CommissionInfo.Commission}}</span>
        </div>

        <div
          class="weui-flex__item"
          :style="formset.IsOnSale==1&&formset.IsState==1&&CommissionInfo.IsState==1&&comboIsState==1&&!CommissionInfo.isSoldOut?'background: #f97334;':'background-color:#999'"
          style="color: white;height:60px"
        >
          <div v-if="requestcomplete">
            <div @click="toLogin()"
              style="margin-top:16px"
              v-if="LoginType==-1"
            >授权登录后购买</div>
            <div
              v-if="formset.IsOnSale==1&&formset.IsState==1&&CommissionInfo.IsState==1&&comboIsState==1&&!CommissionInfo.isSoldOut"
            >
              <span
              @click="Shop()"
                class="price"
                v-if="LoginType==5"
                style="margin-top:10px"
              >{{(CommissionInfo.SalePrice)|currency('￥',2)}} 抢购</span>
              <span
              @click="Shop()"
                class="price"
                v-if="LoginType==4"
              >{{(CommissionInfo.SalePrice-CommissionInfo.DeductAmount)|currency('￥',2)}} 抢购</span>
              <span class="economize" v-if="LoginType==4">省￥{{CommissionInfo.DeductAmount}}</span>
            </div>
            <div
              style="margin-top:16px"
              v-if="formset.IsState!=1||CommissionInfo.IsState!=1||comboIsState!=1"
            >已下架</div>
            <div
              style="margin-top:16px"
              v-if="formset.IsState==1&&CommissionInfo.IsState==1&&comboIsState==1&&CommissionInfo.isSoldOut"
            >已售罄</div>
            <div
            style="margin-top:16px"
            v-if="formset.IsOnSale==0&&formset.IsState==1&&CommissionInfo.IsState==1&&comboIsState==1&&!CommissionInfo.isSoldOut"
          >敬请期待</div>
          </div>
        </div>

        <!-- <div class="weui-flex__item">
          <div v-if="requestcomplete">
            <button
              @click="Shop()"
              v-if="formset.IsOnSale==1&&formset.IsState==1&&CommissionInfo.IsState==1&&comboIsState==1&&!CommissionInfo.isSoldOut"
              class="qg"
            >立即抢购</button>
            <button
              style="background-color:#999"
              v-if="formset.IsOnSale==0&&formset.IsState==1&&CommissionInfo.IsState==1&&comboIsState==1&&!CommissionInfo.isSoldOut"
              class="qg"
            >立即抢购</button>
            <button
              style="background-color:#999"
              v-if="formset.IsState!=1||CommissionInfo.IsState!=1||comboIsState!=1"
              class="qg"
            >已下架</button>
            <button
              style="background-color:#999"
              v-if="formset.IsState==1&&CommissionInfo.IsState==1&&comboIsState==1&&CommissionInfo.isSoldOut"
              class="qg"
            >已售罄</button>
          </div>
        </div>-->
      </div>
    </footer>
  </div>
</template>

<script>
import { Toast } from "we-vue";
import Vue from "vue";
import thumb from "../../assets/logo.png";
import sharereminder from "../../assets/img/shareno.png";
import poster from "../../assets/img/poster.png";
import advisory from "../../assets/img/advisory.png";
import shoppingcart from "../../assets/img/shoppingcart.png";
import share from "../../assets/img/share.png";
import imgloading from "@/assets/img/svg-loader/circles.svg";
import imgerror from "@/assets/img/default-img.png";
import gototop from "@/assets/img/goToTop.png";
import homelink from "@/assets/img/home_link.png";
import home from "../../assets/img/home.png";
import { Dialog } from "we-vue";
import wx from "weixin-js-sdk";
import Clipboard from "clipboard";

export default {
  name: "productdetail",
  data: function() {
    return {
      borwser: this.GLOBAL.borwser,
      LoginType: -1, //(-1=未登录/4=家游客/5=直客)
      LoginGuid: "", //当前登录家游客用户的guid
      IsAlreadyGetRole: 0, //是否已经获取角色
      productGuid: "",
      disid: "",
      posterurl: "",
      posterbase64: "",
      generateposter: "", //=1标志微信授权回调后立即生成海报
      popupVisiblelogo: false, //海报生成logo选择弹出是否显示
      posterOrShowTitle: false, //生成海报或查看产品分享信息
      popupProductInfo: false, //套餐选择
      sharereminder: sharereminder,
      logourl: thumb,
      shoppingcart: shoppingcart,
      advisory: advisory,
      poster: poster,
      share: share,
      shareurl: "",
      shareurl1: "",
      gototop: gototop,
      homelink: homelink,
      home: home,
      imglazy_container: {
        //懒加载图片配置
        selector: "img",
        loading: imgloading,
        error: imgerror
      },

      formset: {SysCompany:{
        ShopName:"",
        CreateTime :"",
        ProductCount:1
      },
        ProductImgUrl:['']},
      comboguid: "",
      comboIsState: 1,
      comboTags: [],
      BusinessInfos: [],
      Tags: ["套餐详情", "产品详情", "预定须知", "退改说明"],
      PagePosition: "ComboContent",
      floattab: false,
      allCount: 1,
      SelectLogos: [
        {
          label: "壹选生活",
          value: 1
        },
        // {
        //   label: "家游客单位",
        //   value: 2
        // },
        {
          label: "微信个人信息",
          value: 3
        }
      ],
      logochoose: [1, 3],
      CommissionInfo: {
        Commission: "",
        ComboContent: "",
        DeductAmount: "",
        SalePrice: "",
        FXPrice: "",
        PriceType: ""
      },
      ComboOptions: [],
      markDate: [],
      chooseDay: null,
      popupVisiblediy: false,
      popupVisibleshare: false,
      showcalendar: true,
      timer_day: 0,
      timer_hour: 0,
      timer_min: 0,
      timer_sec: 0,
      requestcomplete: false,
      scrollTop:0,
      products:[],
      NewTotalCount: -1,
      PageNum: 0, //当前页码
      HasNextPage: true,
      GeneratePoserOrShowTitle: 1, //1=生成海报/2=查看分享信息
      Province:"",
      City:"",
      District :"",
      isRefusePostArea: false,
      IsFreeShipping: 0,
      currentPostage: 0,
      deliveryAddressID: 0,
      isdisabled: true,
      popupProductInfoFlag:false,
      LocationInfoAddress:'',
      LocationInfoLatitude:'',
      LocationInfoLongitude:'',
      LocationFlag:false
    };
  },

  created: function() {
    var deliveryAddressID = localStorage.getItem("chooseaddress");
    if (
      deliveryAddressID != null &&
      deliveryAddressID != undefined &&
      deliveryAddressID.length > 0
    ) {
      this.deliveryAddressID = deliveryAddressID;
      localStorage.removeItem("chooseaddress");
    }
    this.productGuid = this.$route.query.id;
    this.generateposter = this.$route.query.generateposter;
    this.shareurl = location.href;
    this.shareurl1 = location.href;
    var disid = this.$route.query.disid;
    if (disid != undefined && disid != null && disid.length > 0) {
      this.disid = disid;
      localStorage.setItem("disid", disid);
    } else {
      disid = localStorage.getItem("disid");
      if (disid != undefined && disid != null && disid.length > 0) {
        this.disid = disid;
      }
    }
    
    let that = this;
    this.$http
      .get(this.GLOBAL.BASE_URL + "api/tbproduct/getwxinfo", {
        params: {
          url: location.href.split("#")[0]
        }
      })
      .then(function(d) {
        var rep = JSON.parse(d.bodyText);
        if (rep.Success) {
          if(wx!=null){
            wx.config({
              debug: false, // 开启调试模式,
              appId: rep.Data.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
              timestamp: rep.Data.timpstamp, // 必填，生成签名的时间戳
              nonceStr: rep.Data.nonceStr, // 必填，生成签名的随机串
              signature: rep.Data.sign, // 必填，签名，见附录1
              jsApiList: [
                "updateAppMessageShareData",
                "updateTimelineShareData",
                "getLocation"
              ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            });

            wx.ready(function() {
              wx.getLocation({
                type:"gcj02",
                success: function (res) {
                  //_this.getDistrict(res.latitude, res.longitude)
                  console.log("纬度："+res.latitude,"经度"+ res.longitude)
                  that.getDistrict(res.latitude,res.longitude,that);
                },
                cancel: function (res) {
                  // this.InitProduct();
                  // this.InitNewProduct();
                  that.getDistrict(0,0,that);
                },
                error: function (res) {
                  // this.InitProduct();
                  // this.InitNewProduct();
                  that.getDistrict(0,0,that);
                }
              })
            });
          }else
          {
            //that.getDistrict(32.07835388183594,118.7593765258789,that);
          }
        } else {
          Toast.fail(rep.Message);
          that.getDistrict(0,0,that);
        }
      });
      this.InitProduct();
      this.InitNewProduct();
    //this.getDistrict(31.54,119.11);
  },

  mounted: function() {
    var url = window.location.href;
    var code = this.GetRequest(url)["code"];
    var isgetrole = this.$route.query.isgetrole;
    //存在code并且不是用于获取角色
    if (code != undefined && isgetrole != "1") {
      //绑定微信
      console.info(code);
      this.BindWechat(code);
    }
    // this.$nextTick(function() {
    //   //修改事件监听
    //   window.addEventListener("scroll", this.handleScroll, true);
    // });
  },
  destroyed() {
    //window.removeEventListener("scroll", this.handleScroll, true);
  },
beforeRouteLeave (to, from, next) {
    //this.scrollTop = Math.floor(document.body.scrollTop || document.documentElement.scrollTop || window.pageXOffset)
    //console.log("进入"this.scrollTop)
    next()
  },beforeRouteEnter (to, from, next) {
    next(vm => {
      //console.log(this.scrollTop)
      //document.body.scrollTop = vm.scrollTop
    })
  },
  methods: {
    todeliveryaddress: function() {
      this.$router.push({
        path: "/page/deliveryaddress",
        query: { type: "chooseaddress" }
      });
    },
  getDistrict(latitude, longitude,that) {
    if(that.LocationInfoAddress==''){
      // longitude+=0.005444;
      // latitude+=0.002401;
    this.$axios
        .get('/ws/geocoder/v1/?location='+latitude+','+longitude+'&key=OMTBZ-DXYCX-O3H4O-ZZX2A-YHECK-OXFTQ')
        .then(res => {
            
          console.log(res)
            that.LocationInfoAddress=res.data.result.address;
            that.LocationInfoLatitude=latitude;
            that.LocationInfoLongitude=longitude;
            if(!that.LocationFlag)
            {
            var scource = (window.__wxjs_environment == 'miniprogram'?1:0);
          this.$http
            .get(this.GLOBAL.BASE_URL + "api/tbrollcode/wirterecord", {
                params: {
                url: location.href,
                productGuid:that.productGuid,
                disid:localStorage.getItem("disid"),
                address:address,
                latitude:latitude,
                longitude:longitude,
                scource:scource
                }
            })
            .then(function(d) {
                console.log(d);
            });
              that.LocationFlag=true;
            }
            if(that.Province==null||that.Province=="")
            {
              // 省
              that.Province = res.data.result.address_component.province;
              // 市
              that.City = res.data.result.address_component.city;
              // 区
              that.District = res.data.result.address_component.district;
            }
            console.log(that.Province);
            console.log(that.City);
            console.log(that.District);
            console.log(that.LocationInfoAddress);
            console.log(that.LocationInfoLatitude);
            console.log(that.LocationInfoLongitude);
            
        })
        .catch(e => {
          console.log(e);
        });
    }
  },
    calculatePostFee: function() {
      //debugger;
      var goodAmount = this.allCount;
      var postPrice = 0;
      if (this.IsFreeShipping == 0) {
        var provinceName = this.Province;
        var cityName = this.City;
        //查出地址中城市的代号
        var cityCode = this.matchProvinceAndCity(provinceName, cityName);
        //先看是否是不发货地区true是不发货地区，false代表是发货地区
        var isRefuseArea = this.seacrhIsRefuseArea(cityCode);
        this.isRefusePostArea = isRefuseArea;
        //匹配是否是指定运费地区,如果是则计算价格并返回
        if (isRefuseArea) {
          this.isRefuseArea = false;
        }
        if (!isRefuseArea) {
          var objspecial = this.searchIsSpecialArea(cityCode, goodAmount);
          if (objspecial.isSpecial) {
            this.currentPostage = objspecial.postPrice;
            this.Calculaterice();
            return;
          }
        }
        //以上都不是，怎根据默认运费收取快递费
        if (!isRefuseArea) {
          postPrice = this.calculateDefaultPrice(goodAmount);
          this.currentPostage = postPrice;
          this.Calculaterice();
          return;
        }
      } else if (this.IsFreeShipping == 1) {
        this.currentPostage = 0;
        this.Calculaterice();
        return;
      }
    },

    choosePostage: function(amount) {
      if (this.isnotFreeArea) {
        this.currentPostage =
          this.formset.ComboFreightTemplate.Postage + amount;
      } else {
        this.currentPostage = amount;
      }

      this.showchoosePostage = false;
    },
    showPostage: function() {
      this.showchoosePostage = true;
    },

    Calculaterice: function() {
      //debugger;
      (this.allSalePrice = this.allCount * this.formset.SalePrice),
        (this.allCommission = this.allCount * this.formset.Commission),
        (this.allSettlementPrice = (
          this.allCount * this.formset.SettlementPrice
        ).toFixed(2));
      var p1 = this.currentPostage - 0 + this.allSalePrice - this.allCommission;
      var p2 = this.allSalePrice - 0 + this.currentPostage;
      if (this.currentPostage == 0) {
        this.IsFreeShipping = 1;
      }
    },

    calculateDefaultPrice: function(goodAmount) {
      var postPrice = 0;
      var thisfamount = parseInt(this.defaultArea.mamount);
      var thisfprice = parseInt(this.defaultArea.mprice).toFixed(2);
      var thisoamount = parseInt(this.defaultArea.addamount);
      var thisoprice = parseInt(this.defaultArea.addprice).toFixed(2);
      if (goodAmount <= thisfamount) {
        postPrice = parseInt(thisfprice);
      } else {
        var maincount = parseInt((goodAmount - thisfamount) / thisoamount); //超出首件的数量的整数倍数
        var partcount = (goodAmount - thisfamount) % thisoamount; //超出首件的数量的整数余数
        postPrice = parseInt(maincount * thisoprice) + parseInt(thisfprice);
        if (partcount != 0) {
          postPrice += parseInt(thisoprice);
        }
      }
      return postPrice;
    },

    //匹配是否是指定运费地区,如果是则计算价格并返回
    searchIsSpecialArea: function(cityCode, goodAmount) {
      var postPrice = 0;
      var isSpecial = false;
      var specialAreaMeaagageList = this.specialArea;
      for (var i = 0; i < specialAreaMeaagageList.length; i++) {
        var thisspecialAreaCodeStr = specialAreaMeaagageList[i].areaId;
        var thisfamount = parseInt(specialAreaMeaagageList[i].famount);
        var thisfprice = parseInt(specialAreaMeaagageList[i].fprice);
        var thisoamount = parseInt(specialAreaMeaagageList[i].oamount);
        var thisoprice = parseInt(specialAreaMeaagageList[i].oprice);
        if (thisspecialAreaCodeStr.indexOf(",") > 0) {
          var thisspecialAreaCodeList = thisspecialAreaCodeStr.split(",");
          if (thisspecialAreaCodeList.indexOf(cityCode) != -1) {
            isSpecial = true;
            if (goodAmount <= thisfamount) {
              postPrice = thisfprice;
            } else {
              var maincount = parseInt(
                (goodAmount - thisfamount) / thisoamount
              ); //超出首件的数量的整数倍数
              var partcount = (goodAmount - thisfamount) % thisoamount; //超出首件的数量的整数余数
              postPrice =
                parseInt(maincount * thisoprice) + parseInt(thisfprice);

              if (partcount != 0) {
                postPrice += parseInt(thisoprice);
              }
            }
          }
        } else {
          if (thisspecialAreaCodeStr == cityCode) {
            isSpecial = true;
            if (goodAmount <= thisfamount) {
              postPrice = thisfprice;
            } else {
              var maincount = parseInt(
                (goodAmount - thisfamount) / thisoamount
              ); //超出首件的数量的整数倍数
              var partcount = (goodAmount - thisfamount) % thisoamount; //超出首件的数量的整数余数
              postPrice =
                parseInt(maincount * thisoprice) + parseInt(thisfprice);

              if (partcount != 0) {
                postPrice += parseInt(thisoprice);
              }
            }
          }
        }
      }
      var objspecial = {};
      objspecial.postPrice = postPrice;
      objspecial.isSpecial = isSpecial;
      return objspecial;
    },

    //查询是否是不发货地区
    seacrhIsRefuseArea: function(cityCode) {
      var isRefuseArea = true;
      var dCityCodeStr = this.refuseArea.noareaId;
      if (
        dCityCodeStr != null &&
        dCityCodeStr != undefined &&
        dCityCodeStr != ""
      ) {
        if (dCityCodeStr.indexOf(",") > 0) {
          var dCityCodeList = dCityCodeStr.split(",");
          if (dCityCodeList.indexOf(cityCode) == -1) {
            isRefuseArea = false;
          }
        } else {
          if (dCityCodeStr != cityCode) {
            isRefuseArea = false;
          }
        }
      } else {
        isRefuseArea = false;
      }
      return isRefuseArea;
    },
    //根据省份名字和城市名获得城市Code
    matchProvinceAndCity: function(provinceName, cityName) {
      var cityCode = "";
      for (var i = 0; i < this.ProvinceCityTreeList.length; i++) {
        if (this.ProvinceCityTreeList[i].Name == provinceName) {
          var innerCityList = this.ProvinceCityTreeList[i].Children;
          for (var j = 0; j < innerCityList.length; j++) {
            if (innerCityList[j].Name == cityName) {
              cityCode = innerCityList[j].ID;
              break;
            }
          }
          break;
        }
      }
      return cityCode;
    },
    toLogin: function() {
      if(this.LoginType==-1)
      {
        var returnurl = undefined;
        if (location.hash != undefined && location.hash != null && location.hash.length > 0) {
            returnurl = location.hash.substr(1);
        }
        window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + this.GLOBAL.appid + "&redirect_uri=" + this.GLOBAL.redirect_uri + "%23%2Faccount%2Fgetroleandlogin%3Fjumpurl%3D" + encodeURIComponent(returnurl) + "&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
      }
      // else if (this.LoginType == 4) {
      //   this.$router.push("/account/login?type=dis");
      // } else {
      //   this.$router.push("/account/login");
      // }
    },
    clicktocopy: function() {
      //this.$router.back();
      //copy 标题
      var clipboard = new Clipboard("#copyBtn");
      clipboard.on("success", function(e) {
        Toast.success("复制成功");
        e.clearSelection();
      });
      // return;
    },
    copyshareurl: function(idStr) {
      var clipboard1 = new Clipboard("#"+idStr);
      clipboard1.on("success", function(e) {
        Toast.success("复制链接成功");
        e.clearSelection();
      });
      this.popupVisiblelogo = false;
      this.posterOrShowTitle = false;
      //return;
    },
    goto: function(pagePosition) {
      this.PagePosition = pagePosition;
      document.getElementById(pagePosition).scrollIntoView();
    },
    // handleScroll() {
    //   this.scrollTop =
    //     window.pageYOffset ||
    //     document.documentElement.scrollTop ||
    //     document.body.scrollTop;
    //   var a = document.getElementById("ComboContent").offsetTop;
    //   var b = document.getElementById("ProductContent").offsetTop;
    //   var c = document.getElementById("ReservationContent").offsetTop;
    //   var d = document.getElementById("ChangeContent").offsetTop;
    //   if (this.scrollTop > a - 50) {
    //     //todo
    //     this.floattab = true;
    //     //document.getElementById("ComboContent").scrollTop(200)
    //     this.PagePosition = "ComboContent";
    //     if (this.scrollTop > b - 50) {
    //       this.PagePosition = "ProductContent";
    //     }
    //     if (this.scrollTop > c - 50) {
    //       this.PagePosition = "ReservationContent";
    //     }
    //     if (this.scrollTop > d - 50) {
    //       this.PagePosition = "ChangeContent";
    //     }
    //   } else {
    //     this.floattab = false;
    //     this.PagePosition = "ComboContent";
    //   }
    // },
    ToHome: function() {
      window.location.href = this.GLOBAL.WEB_URL + "/#/app/home";
    },
    ToMyFSX: function() {
      window.location.href =
        this.GLOBAL.WEB_URL +
        "/#/page/productdetail?id=" +
        this.productGuid +
        "&disid=" +
        this.LoginGuid;
      this.shareurl = location.href;
      this.shareurl1 = location.href;
    },
    setcache: function() {
      var promise = this.$http.get(this.GLOBAL.BASE_URL + "api/getdict");
      promise.then(function(d) {
        var rep = JSON.parse(d.bodyText);
        if (rep.Success) {
          localStorage.setItem("cachedict", JSON.stringify(rep.Data));
        } else {
          Toast.fail(rep.Message);
        }
      });
    },
    //获取用户角色
    GetRole: function(code) {
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/login/getrole", {
          params: {
            code: code
          }
        })
        .then(function(d) {
          var rep = JSON.parse(d.bodyText);
          if (rep.Success) {
            this.LoginGuid = rep.Data.UserGuid;
            this.LoginType = rep.Data.LoginType;
            if (this.LoginType == 4 && this.LoginGuid != this.disid) {
              this.ToMyFSX();
            }
            if (rep.Data.Token.length > 0) {
              this.IsAlreadyGetRole = rep.Data.IsAlreadyGetRole;
              localStorage.setItem("token", JSON.stringify(rep.Data.Token));
              this.setcache();
              this.InitProduct();
            }
          } else {
            //Toast.fail(rep.Message);
          }
        });
    },

    BindWechat: function(code) {
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/login/bindwechat", {
          params: {
            code: code
          }
        })
        .then(function(d) {
          var rep = JSON.parse(d.bodyText);
          if (rep.Success) {
            //绑定成功
            window.location.href =
              this.GLOBAL.WEB_URL +
              "/#/page/productdetail?id=" +
              this.productGuid +
              "&disid=" +
              this.disid +
              "&generateposter=1";
          } else {
            Toast.fail(rep.Message);
          }
        });
    },
    CalculatePostFee:function(){

    },
    //购买
    Shop: function() {
      //_hmt.push(["_trackEvent", "抢购", "提交", "产品抢购"]);
      if(this.formset.ComboOptions.length>1&&!this.popupProductInfoFlag)
      {
        this.PopupProductInfo();
      }else{
      if (this.comboguid == "") {
        Toast.fail("请先选择套餐");
        return;
      }
      if (this.CommissionInfo.PriceType == "2" && this.chooseDay == null) {
        Toast.fail("请先选择团期");
        return;
      }
      var typeofguid = "";
      if (this.CommissionInfo.PriceType == "1") {
        //单团
        typeofguid = this.comboguid;
      } else if (this.CommissionInfo.PriceType == "2") {
        //多团
        typeofguid = this.chooseDay.guid;
      }
      this.popupProductInfo=false;
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/tbproduct/judgeNewOrOld", {
          params: {
            comboxGuid: this.comboguid
          }
        })
        .then(function(d) {
          //debugger
          var rep = JSON.parse(d.bodyText);
          if (rep.Success) {
            var status=rep.Data;
            var gotopageUrl = "/page/productpreorder";
            if (!status) {
              gotopageUrl = "/page/oldproductpreorder";
            }
            var disid = this.$route.query.disid; //家游客id，用于分配佣金
            if (disid != undefined && disid != null && disid.length > 0) {
              this.$router.push({
                path: gotopageUrl,
                query: {
                  type: this.CommissionInfo.PriceType,
                  typeofguid: typeofguid,
                  allCount: this.allCount,
                  disid: this.$route.query.disid,
                  stype: this.$route.query.stype
                }
              });
            } else {
              this.$router.push({
                path: gotopageUrl,
                query: {
                  type: this.CommissionInfo.PriceType,
                  typeofguid: typeofguid,
                  allCount: this.allCount,
                  stype: this.$route.query.stype
                }
              });
            }
          } else {
            Toast.fail(rep.Message);
          }
        });
      }
    },
    //生成海报或分享信息
    PosterOrShowTitle: function() {
      this.posterOrShowTitle = true;
    },
    PopupProductInfo: function() {
      this.popupProductInfo = true;
      this.popupProductInfoFlag = true;
    },

    //查看分享信息
    showTitlePre: function() {
      this.GeneratePoserOrShowTitle = 2;
      //供应商设计好海报则查看，否则家游客自定义生成后查看
      if (this.formset.IsPostPoster == 1) {
        this.GeneratePoster();
      } else {
        this.popupVisiblelogo = true;
      }
    },

    GeneratePosterPre: function() {
      this.GeneratePoserOrShowTitle = 1;
      //供应商设计好海报则直接生成，否则家游客自定义生成
      if (this.formset.IsPostPoster == 1) {
        this.GeneratePoster();
      } else {
        this.popupVisiblelogo = true;
      }
    },

    GeneratePoster: function() {
      //_hmt.push(["_trackEvent", "海报", "生成", "生成海报"]);
      this.popupVisiblelogo = false;
      this.posterOrShowTitle = false;
 
      var data = {
        ProductGuid: this.productGuid,
        IsPostPoster: this.formset.IsPostPoster,
        LogoChoose: this.logochoose,
        IsMiniProgram: (window.__wxjs_environment == 'miniprogram'?1:0)
      };

      if (this.GeneratePoserOrShowTitle == 2) {
        //附带生成海报的产品到分享标题页
        var info = JSON.stringify(data);
        this.$router.push({
          path: "/page/showtitle",
          query: {
            info: info
          }
        });
      } else {
        this.$store.commit("showLoading");
        this.$http
          .post(this.GLOBAL.BASE_URL + "api/tbproduct/generateposter", data, {
            emulateJSON: true
          })
          .then(function(d) {
            var rep = JSON.parse(d.bodyText);
            if (rep.Success) {
              this.posterbase64 = rep.Data;
              this.popupVisiblediy = true;
            } else {
              if (
                rep.Message == "请先授权微信公众号" &&
                this.borwser == "wechat"
              ) {
                window.location.href =
                  "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
                  this.GLOBAL.appid +
                  "&redirect_uri=" +
                  this.GLOBAL.redirect_uri +
                  "%23%2Fpage%2Fproductdetail%3Fid%3D" +
                  this.productGuid +
                  "%26disid%3D" +
                  this.disid +
                  "%26stype%3D" +
                  this.this.$route.query.stype +
                  "&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
              } else {
                Toast.fail(rep.Message);
              }
            }
            this.$store.commit("hideLoading");
          });
      }
    },
    onChange: function(value) {
      this.comboguid=value;
      this.showcalendar = false;
      let _this = this;
      setTimeout(function() {
        _this.showcalendar = true;
      }, 250); //延迟执行曲线刷新日历控件
      (this.chooseDay = null),
        (this.CommissionInfo = {
          Commission: "",
          DeductAmount: "",
          SalePrice: "",
          FXPrice: "",
          PriceType: ""
        });
      this.markDate = [];
      if (this.formset.CommissionInfo != null) {
        for (var key in this.formset.CommissionInfo) {
          if (value == key) {
            this.CommissionInfo = this.formset.CommissionInfo[key];
            break;
          }
        }
        for (var key in this.formset.ComboPriceInfo) {
          if (value == key) {
            this.markDate = this.formset.ComboPriceInfo[key];
            if (
              this.markDate != undefined &&
              this.markDate != null &&
              this.markDate.length > 0
            ) {
              for (var item in this.markDate) {
                if (this.markDate[item].chooseDay == false) {
                  this.markDate[item].chooseDay = true;
                  break;
                }
              }
              for (var item in this.markDate) {
                if (this.markDate[item].chooseDay == true) {
                  this.chooseDay = this.markDate[item];
                  break;
                }
              }
            }
            break;
          }
        }
      }
      //获取当前套餐的上下架和套餐标签
      for (var item in this.formset.ComboOptions) {
        if (this.formset.ComboOptions[item].value == value) {
          this.comboIsState = this.formset.ComboOptions[item].isState;
          this.comboTags = this.formset.ComboOptions[item].comboTags;
          this.BusinessInfos = this.formset.ComboOptions[item].BusinessInfos;
          this.formset.ComboName = this.formset.ComboOptions[item].label;
        }
      }
      //document.getElementById("dvComPop").style.height="100%";
    },
    changeDate: function(changeday) {},
    clickDay: function(chooseday) {
      this.chooseDay = chooseday;
      for (var item in this.markDate) {
        if (this.markDate[item].chooseDay == true) {
          this.markDate[item].chooseDay = false;
          break;
        }
      }
      for (var key in this.markDate) {
        if (chooseday.guid == this.markDate[key]["guid"]) {
          this.CommissionInfo = {
            Commission: this.markDate[key].Commission,
            DeductAmount: this.markDate[key].DeductAmount,
            SalePrice: this.markDate[key].price,
            FXPrice: this.markDate[key].FXPrice,
            PriceType: 2,
            isSoldOut: this.markDate[key].isSoldOut,
            PrimePrice: this.markDate[key].PrimePrice,
            IsState: this.markDate[key].IsState,
            AllSoldCount: this.markDate[key].AllSoldCount,
            AllStockCount: this.markDate[key].AllStockCount,
            IsShowStock: this.markDate[key].IsShowStock
          };
        }
      }
    },
    InitNewProduct: function(type) {
      this.PageNum += 1;
      var data = {
        ProductName: "",
        IsOrderByPriceAsc: null,
        ProductTypes: [],
        ScenicareaId: null,
        HoltelId: null,
        PageSize: 4,
        PageNum: this.PageNum,
        LoginType: -1
      };
      this.$http
        .post(this.GLOBAL.BASE_URL + "api/tbproduct/productpager", data, {
          emulateJSON: true
        })
        .then(function(d) {
          var rep = JSON.parse(d.bodyText);
          if (rep.Success) {
            this.products = rep.Data.List;
            //this.disid = rep.Data.DisGuid;
            this.HasNextPage = rep.Data.Page.HasNextPage;
            this.NewTotalCount = rep.Data.Page.Total;
            var i = 0;
            for (; i < this.products.length; i++) {
              if (this.products[i].ProductName.length > 20) {
                this.products[i].ProductName =
                  this.products[i].ProductName.substring(0, 20) + "...";
              }
            }
          } else {
            Toast.fail(rep.Message);
          }
        });
    },
    //产品详情
    ProductDetail: function(orderGuid) {
      this.productGuid = orderGuid;
      // if (this.LoginType == 4) {
      //   this.$router.push({
      //     path: "/page/productdetail",
      //     query: {
      //       id: orderGuid,
      //       disid: this.disid
      //     }
      //   });
      // } else {
      //   this.$router.push({
      //     path: "/page/productdetail",
      //     query: {
      //       id: orderGuid
      //     }
      //   });
      // }      
      this.InitProduct();
    },
    InitProduct: function(type) {
     window.scroll(0, 0); 
      this.$store.commit("showLoading");
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/tbproduct/get", {
          params: {
            productGuid: this.productGuid,
            disid: (this.disid==null?"":this.disid),
            deliveryAddressID: this.deliveryAddressID
          }
        })
        .then(function(d) {
          var rep = JSON.parse(d.bodyText);
          if (rep.Success) {
            this.LoginType = rep.Data.LoginType;
            this.LoginGuid = rep.Data.LoginGuid;
            if (this.LoginType == 4 && this.LoginGuid != this.disid) {
              this.ToMyFSX();
            }
            //附带disid进入产品详情页更新是否显示精选页面
            if (
              this.disid != undefined &&
              this.disid != null &&
              this.disid.length > 0
            ) {
              localStorage.setItem("showFun", rep.Data.IsShowFun);
              this.$store.commit("showFun");
            }
            this.formset = rep.Data;
            if (this.formset.IsOnSale == 0) {
              this.countdowm(this.formset.OnSaleDate);
            }
            var token = localStorage.getItem("token");
            //用户自己退出的情况不做自动登录
            var isAutoLogin =
              token != undefined && token != null && token.length > 0;
            if (
              this.LoginType == -1 &&
              this.borwser == "wechat" &&
              isAutoLogin
            ) {
              var url = window.location.href;
              var code = this.GetRequest(url)["code"];
              if (code != undefined && this.IsAlreadyGetRole == 0) {
                //获取用户角色
                this.IsAlreadyGetRole = 1;
                this.GetRole(code);
              }
              if (
                this.disid != undefined &&
                this.disid != null &&
                this.disid.length > 0 &&
                this.IsAlreadyGetRole == 0
              ) {
                //用户授权获取用户openid，判断用户角色

                window.location.href =
                  "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
                  this.GLOBAL.appid +
                  "&redirect_uri=" +
                  this.GLOBAL.redirect_uri +
                  "%23%2Fpage%2Fproductdetail%3Fid%3D" +
                  this.productGuid +
                  "%26disid%3D" +
                  this.disid +
                  "%26isgetrole%3D" +
                  "1" +
                  "&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
              }
            }
            if(this.formset.DeliveryAddress!=null){
            this.Province = this.formset.DeliveryAddress.Province;
            this.City = this.formset.DeliveryAddress.City;
            this.District = this.formset.DeliveryAddress.Area;
            }else if(this.Province==""){
              this.Province ="";
              this.City ="";
              this.District ="";
            }
            if (this.LoginType != -1) {
            }
            if (this.generateposter == "1") {
              //初始化页面时生成海报
              this.GeneratePosterPre();
            }

            let that = this;
            wx.ready(function() {
            if(that.Province==null||that.Province=="")
            {
                wx.getLocation({
                  type:"gcj02",
                  success: function (res) {
                    //_this.getDistrict(res.latitude, res.longitude)
                    console.log("纬度："+res.latitude,"经度"+ res.longitude)
                    that.getDistrict(res.latitude,res.longitude,that);
                  },
                  cancel: function (res) {
                    if(that.Province==null||that.Province=="")
                    {
                      that.Province ="江苏省";
                      that.City ="南京市";
                      that.District ="鼓楼区";
                    }
                  },
                  error: function (res) {
                    if(that.Province==null||that.Province=="")
                    {
                      that.Province ="江苏省";
                      that.City ="南京市";
                      that.District ="鼓楼区";
                    }
                  }
                })
            }
              //需在用户可能点击分享按钮前就先调用
              wx.updateAppMessageShareData({
                //分享给朋友和qq
                title: that.formset.ProductName, // 分享标题
                desc: that.formset.ComboName, // 分享描述
                link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: encodeURI(that.formset.ProductImgUrl[0]), // 分享图标
                success: function() {
                  //alert(location.href);
                }
              });

              wx.updateTimelineShareData({
                //分享给朋友圈和qq空间
                title: that.formset.ProductName, // 分享标题 "壹选生活优选商城"
                link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: that.formset.ProductImgUrl[0], //that.formset.ProductImgUrl[0], // 分享图标
                success: function() {}
              });
              wx.error(function(err) {
                //alert(JSON.stringify(err));
              });
            });
            if (
              this.formset.ComboOptions != null &&
              this.formset.ComboOptions.length > 0
            ) {
              this.ComboOptions = this.formset.ComboOptions;
              for (var key in this.ComboOptions) {
                if (
                  !this.ComboOptions[key].isSoldOut &&
                  this.ComboOptions[key].isState == 1
                ) {
                  this.comboguid = this.ComboOptions[key].value;
                  this.comboIsState = this.ComboOptions[key].isState;
                  this.comboTags = this.ComboOptions[key].comboTags;
                  this.BusinessInfos = this.ComboOptions[key].BusinessInfos;
                  this.onChange(this.comboguid);
                  break;
                }
              }
              if (this.comboguid == "") {
                for (var key in this.ComboOptions) {
                  this.comboguid = this.ComboOptions[key].value;
                  this.comboIsState = this.ComboOptions[key].isState;
                  this.comboTags = this.ComboOptions[key].comboTags;
                  this.BusinessInfos = this.ComboOptions[key].BusinessInfos;
                  break;
                }
              }
            }
            this.requestcomplete = true;
            if(this.CommissionInfo.NewFreightTemplate!=null){
              this.defaultArea = JSON.parse(
                this.CommissionInfo.NewFreightTemplate.DefaultFreight
              );
              this.specialArea = JSON.parse(
                this.CommissionInfo.NewFreightTemplate.DeliveryFreight
              );
              this.refuseArea = JSON.parse(
                this.CommissionInfo.NewFreightTemplate.NotDeliveryArea
              );
              //省份城市tree
              this.ProvinceCityTreeList = this.formset.ProvinceCityTreeList;
              this.IsFreeShipping = this.CommissionInfo.NewFreightTemplate.IsFreeShipping;
              this.calculatePostFee(this.allCount);
            }else if (
              this.CommissionInfo.ComboFreightTemplate.NotFreeShippingArea !=
                undefined &&
              this.CommissionInfo.ComboFreightTemplate.NotFreeShippingArea != null &&
              this.CommissionInfo.ComboFreightTemplate.NotFreeShippingArea.length > 0
            ) {
              for (
                var i = 0;
                i <
                this.CommissionInfo.ComboFreightTemplate.NotFreeShippingArea.length;
                i++
              ) {
                if (
                  this.CommissionInfo.ComboFreightTemplate.NotFreeShippingArea[i] ==
                  this.City
                ) {
                  this.isnotFreeArea = true;
                }
              }

              if (
                this.isnotFreeArea &&
                this.CommissionInfo.ComboFreightTemplate.IsFreeShipping == 1
              ) {
                this.currentPostage = this.CommissionInfo.ComboFreightTemplate.Postage;
                this.showchoosePostage = false;
              }
              if (
                this.isnotFreeArea &&
                this.CommissionInfo.ComboFreightTemplate.IsFreeShipping == 0
              ) {
                this.currentPostage =
                  this.CommissionInfo.ComboFreightTemplate.Postage +
                  this.CommissionInfo.ComboFreightTemplate.ExpressAmountInfo[0].Amount;
              }
              if (
                !this.isnotFreeArea &&
                this.CommissionInfo.ComboFreightTemplate.IsFreeShipping == 0
              ) {
                this.currentPostage = this.CommissionInfo.ComboFreightTemplate.ExpressAmountInfo[0].Amount;
              }
              this.Calculaterice();
            }
          } else {
            this.requestcomplete = true;
            Toast.fail(rep.Message);
          }
          this.$store.commit("hideLoading");
          
          if(window.__wxjs_environment == 'miniprogram')
          {
            var tempUrl = "/#/page/productdetail?id="+this.$route.query.id+"&disid="+this.$route.query.disid+"&isrl=1";
            tempUrl = encodeURIComponent(tempUrl);
            wx.miniProgram.postMessage({ data:{disid:this.$route.query.disid,title:this.formset.ProductName,img:encodeURI(this.formset.ProductImgUrl[0]),path:"/pages/index/index?url="+tempUrl} });
            //wx.miniProgram.postMessage({ shareInfo:{title:"壹选生活",img:"http://nongjiam.zhoumochuyou.cn/api/Attachment/downloadadvertiseimg?id=temp/logo0001.png",path:"/pages/index/index"} });
            var isrelocation = this.$route.query.isrl;
            if(isrelocation==null){
              
              
              //wx.miniProgram.redirectTo({url:"/pages/index/index?url="+tempUrl});
              return;
            }
          }
        });
    },
    zixun: function(number) {
      if (number) {
        location.href = "tel:" + number;
        return;
      }
      if (
        this.formset.ProductContactTel == undefined ||
        this.formset.ProductContactTel == null ||
        this.formset.ProductContactTel.length == 0
      ) {
        this.formset.ProductContactTel = "18913840769";
      }
      //location.href = "tel:" + this.formset.ProductContactTel;
      location.href = "tel:18913840769";
    },
    toMap(lng, lat) {
      if (lng && lat) {
        var url = "https://uri.amap.com/marker?position=" + lng + "," + lat;
        window.location.href = url;
      } else {
        Toast.fail("商家未设置位置信息，暂时不能导航");
      }
    },
    countdowm(timestamp) {
      let self = this;
      timestamp = timestamp * 1000;
      let timer = setInterval(function() {
        // let nowTime = new Date();
        // let endTime = new Date(timestamp * 1000);
        let t = timestamp;//endTime.getTime() - nowTime.getTime();
        if (t > 0) {
          timestamp = timestamp - 1000;
          self.timer_day = Math.floor(t / 86400000);
          self.timer_hour = Math.floor((t / 3600000) % 24);
          self.timer_min = Math.floor((t / 60000) % 60);
          self.timer_sec = Math.floor((t / 1000) % 60);
          self.timer_hour =
            self.timer_hour < 10 ? "0" + self.timer_hour : self.timer_hour;
          self.timer_min =
            self.timer_min < 10 ? "0" + self.timer_min : self.timer_min;
          self.timer_sec =
            self.timer_sec < 10 ? "0" + self.timer_sec : self.timer_sec;
        } else {
          self.formset.IsOnSale = 1;
          clearInterval(timer);
        }
      }, 1000);
    }
  }
};
</script>

<style>
.tab-title {
  text-align: center;
  margin-top: 20px;
}
.float-button {
  position: fixed;
  bottom: 210px;
  right: 20px;
  z-index: 100;
  width: 46px;
  height: 46px;
  background-color: #ffffff;
  border: 1px solid #eee9e4;
  text-align: center;
  font-size: 14px;
  border-radius: 30px;
  opacity: 0.9;
}

.products-labels-list span {
  display: inline-block;
  vertical-align: middle;
  margin: 0.075rem 0.5rem 0.75rem 0;
  padding: 0.1rem 0.4rem;
  -moz-border-radius: 0.15rem;
  border-radius: 0.15rem;
  color: white;
  font-size: 0.75rem;
}

.fenxiao-price {
  font-size: 0.875rem;
  margin-left: 1rem;
}

.fenxiao-button {
  font-size: 1rem;
  float: right;
}

.generateandshow {
  background: url(../../assets/img/25.png) no-repeat 5px center;
  background-size: 100% 100%;
  height: 70px;
  width: 100%;
}

.commission {
  font-size: 1.5rem;
  color: #fff;
  display: inline-block;
  vertical-align: middle;
  line-height: 70px;
  margin-left: 10%;
  width: 95px;
}
.generate {
  width: 22%;
  text-align: center;
  padding: 35px 0px;
  background: url("../../assets/img/23.png") center no-repeat;
  background-size: 100% auto;
  display: inline-block;
}
.sharebutton {
  width: 22%;
  text-align: center;
  padding: 35px 0px;
  margin-left: 2%;
  margin-right: 12%;
  background: url("../../assets/img/24.png") center no-repeat;
  background-size: 100% auto;
  display: inline-block;
}
.fenxiao-switch {
  position: fixed;
  bottom: 53px;
  font-size: 0.875rem;
  text-align: center;
  width: 100%;
  background: #fff;
  opacity: 0.8;
  line-height: 40px;
  color: #ff9800;
}
.float-home {
  position: fixed;
  bottom: 160px;
  right: 20px;
  z-index: 100;
  width: 46px;
  height: 46px;
  background-color: #ffffff;
  border: 1px solid #eee9e4;
  text-align: center;
  font-size: 14px;
  border-radius: 30px;
  opacity: 0.9;
}
.tab-activett {
  height: 5rem;
  line-height: 5rem;
  border-bottom: 2px solid #ff7135;
  font-weight: bolder;
  color: #ff7135;
}
.tab-float {
  position: fixed;
  top: 0px;
  display: flex;
  width: 100%;
  z-index: 999;
}

.tab-item-detail {
  padding-left: 15px;
  padding-right: 15px;
}
span .weui-cell__ft {
  width: 82%;
}
.productcontent tab-item-detail {
  font-size: 1.3rem;
}
.productcontent video {
  width:100%;
  height:100%;
}
.countdown-warp {
  text-align: center;
  background-color: #ff7135;
  height: 2.76rem;
  line-height: 2.76rem;
  font-size: 14px;
  color: #444;
}

.countdown-warp span {
  color: #ff5251;
  background-color: #fff;
  padding: 0.3rem;
  text-align: center;
}

.productcopy {
  width: 140px;
  background: #ececec;
  border-radius: 5px;
  padding-left: 10px;
  height: 28px;
}
#producttarget {
  margin-top: 10px;
}

.generateback {
  background: url(../../assets/img/generateposter.png) no-repeat center;
  background-size: 50px;
}
.shareback {
  background: url(../../assets/img/sharetitle.png) no-repeat center;
  background-size: 50px;
}
.shareurl {
  background: url(../../assets/img/shareurl.png) no-repeat center;
  background-size: 50px;
}
</style>





// WEBPACK FOOTER //
// src/components/combo/productdetail.vue